<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{'编辑课程'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small" v-loading="loading">
      <div
        v-for="group in universityGroups"
        :key="group.Id"
      >
        <el-row>
          <span>{{group.NameValue.replace(new RegExp('&', 'gm'), '/')}}</span>
          <hr>
        </el-row>
        <el-form label-width="50px">
          <el-form-item
            :key="index"
            v-for="(teacherCourse,index) in teacherAllCourseList['g'+group.GroupNumber]"
            class="form-item-margin"
          >
            <el-select
              class="el-select-course"
              v-model="teacherCourse.CourseId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in group.CourseList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>

            <a><i
                class="el-icon-close remove-icon"
                @click="removeCourse(index, teacherAllCourseList['g'+group.GroupNumber])"
              ></i></a>
          </el-form-item>

          <el-form-item>
            <el-button
              @click="addCourse(group.GroupNumber)"
              type="primary"
              class="add-teacher-btn"
              icon="el-icon-plus"
              size="mini"
            >
              添加课程
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-row>
          <span>职业培训</span>
          <hr>
        </el-row>
        <el-form label-width="50px">
            <el-form-item
            :key="index"
            v-for="(training,index) in trainings"
            class="form-item-margin"
          >
            <el-select
              class="el-select-course"
              v-model="training.CourseId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in trainingCourseList"
                :key="item.CourseId"
                :label="item.CourseName"
                :value="item.CourseId"
              >
              </el-option>
            </el-select>

            <el-select
              class="el-select-course"
              v-model="training.CampausId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in campaus"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>

            <a><i
                class="el-icon-close remove-icon"
                @click="removeTraining(index, training)"
              ></i></a>
              <hr/>
          </el-form-item>
          
          <el-form-item>
            <el-button
              @click="addTraining(3)"
              type="primary"
              class="add-teacher-btn"
              icon="el-icon-plus"
              size="mini"
            >
              添加职业培训
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-row>
          <span>应试英语</span>
          <hr>
        </el-row>
        <el-form label-width="50px">
            <el-form-item
            :key="index"
            v-for="(englishTraining,index) in englishTrainings"
            class="form-item-margin"
          >
            <el-select
              class="el-select-course"
              v-model="englishTraining.CourseId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in englishTrainingCourseList"
                :key="item.CourseId"
                :label="item.CourseName"
                :value="item.CourseId"
              >
              </el-option>
            </el-select>

            <el-select
              class="el-select-course"
              v-model="englishTraining.CampausId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in campaus"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>

            <a><i
                class="el-icon-close remove-icon"
                @click="removeEnglishTraining(index, englishTraining)"
              ></i></a>
              <hr/>
          </el-form-item>
          
          <el-form-item>
            <el-button
              @click="addTraining(2)"
              type="primary"
              class="add-teacher-btn"
              icon="el-icon-plus"
              size="mini"
            >
              添加应试英语课程
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          v-if="showError"
        >
          <el-alert
            :closable="false"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            type="primary"
            @click="save()"
            :disabled="saving"
          >{{ '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-right {
  float: right;
}
.add-teacher-btn {
  background-color: #59c2e6 !important;
  border-color: #59c2e6 !important;
}

.el-container {
  padding-left: 30px;
  padding-right: 30px;
}

.form-item-margin {
  margin: 0px;
}

.el-select-course {
  width: 300px !important;
}

.remove-icon {
  color: red;
  cursor: pointer;
  margin-left: 10px;
}

.btn-row {
  padding-left: 50px;
}

.footer-left {
  margin-bottom: 15px;
}
</style>

<script>
import {
  getUniversityGroups,
  getCampusList,
  getAllCurrentTermTrainingEnglishCourses,
} from "../../service/common.service";

import { getSpeedupCourseList } from "../../service/speedupCourse.service";

import {
  getTeacherCourseList,
  getTeacherAllCourseList,
  saveSetTeacherCourses
} from "../../service/teacherCourse.service";

export default {
  props: {
    dialogVisible: false,
    teacherId: Number
  },
  data() {
    return {
      saving: false,
      showError: false,
      errorMessage: "",
      universityGroups: [],
      teacherAllCourseList: {},
      trainingCourseList: [],
      englishTrainingCourseList: [],
      campaus: [],
      trainings: [],
      englishTrainings: [],
      loading: false,
      isUniversityLoaded: false,
      isTrainingLoaded: false
    };
  },
  components: {},
  created() {
    this.loading = true;
    this.loadUniversityGroups();
    this.loadTrainingCourses();
    this.loadCampus();
  },
  methods: {
    init(){
      if (this.universityGroups.length == 0){
        return;
      }
      this.loading = true;
      this.isUniversityLoaded = false;
      this.isTrainingLoaded = false;
      this.universityGroups.forEach(r => {
        this.$set(this.teacherAllCourseList, "g" + r.GroupNumber, []);
      });
      this.loadTeacherCourseList();
      this.loadTeacherTrainingCourseList();
    },
    removeCourse(index, courses) {
      courses.splice(index, 1);
    },
    addCourse(groupNumber) {
      let newRow = {
        Id: 0,
        Name: "",
        TeacherId: this.teacherId,
        GroupNumber: groupNumber,
        Enable: true
      };

      this.teacherAllCourseList["g" + groupNumber].push(newRow);
    },
    getTeacherCourseByGroup(groupNumber) {
      return this.teacherAllCourseList.filter(
        r => r.GroupNumber == groupNumber
      );
    },
    loadTeacherCourseList() {
      getTeacherCourseList(this.teacherId).then(result => {
        if (!!result && result.success) {
          let teacherCourseList = result.data.TeacherCourseList;
          this.universityGroups.forEach(r => {
            let courses = teacherCourseList.filter(c => c.GroupNumber == r.GroupNumber);
            this.teacherAllCourseList[
              "g" + r.GroupNumber
            ] = this.teacherAllCourseList["g" + r.GroupNumber].concat(courses);
          });
        }
        this.isUniversityLoaded = true;
        this.checkLoading();
      });
    },
    loadTeacherTrainingCourseList() {
      getTeacherAllCourseList(this.teacherId, true).then(result => {
        if (!!result && result.success) {
          let teacherTrainingCoursesList = result.data.TeacherTrainingCourseList;
          teacherTrainingCoursesList.forEach(r => {
            let newRow = {
              CourseId: r.CourseId,
              CampausId: r.CampausId,
              TrainingCategoryId: r.TrainingCategoryId,
              CourseType: r.CourseType
            }
            if(newRow.CourseType == 3){
              this.trainings.push(newRow);
            }
            if(newRow.CourseType == 2){
              this.englishTrainings.push(newRow);
            }
          });
        }
        this.isTrainingLoaded = true;
        this.checkLoading();
      });
    },
    checkLoading(){
      if (this.isUniversityLoaded && this.isTrainingLoaded){
        this.loading = false;
      }
    },
    loadTrainingCourses(){
      //培训课程
      getAllCurrentTermTrainingEnglishCourses().then(res => {
        this.trainingCourseList = res.data[3];
        this.englishTrainingCourseList = res.data[2];
      });
    },
    loadCampus(){
      //校区
      getCampusList().then(res=>{
        this.campaus = res.data;
      });
    },
    loadUniversityGroups() {
      getUniversityGroups(false, true).then(result => {
        if (!!result && result.success) {
          this.universityGroups = result.data;
          if (this.universityGroups && this.universityGroups.length > 0) {
            this.universityGroups.forEach(r => {
              this.getCourseListByGroup(r, r.GroupNumber);
              this.$set(this.teacherAllCourseList, "g" + r.GroupNumber, []);
            });
            this.init();
          }
        }
      });
    },
    getCourseListByGroup(group, universityGroup) {
      getSpeedupCourseList(universityGroup, "").then(result => {
        if (!!result && result.success) {
          this.$set(group, "CourseList", result.data);
        }
      });
    },
    removeTraining(index, training){
      this.trainings.splice(index, 1);
    },
    removeEnglishTraining(index, englishTraining){
      this.englishTrainings.splice(index, 1);
    },
    addTraining(courseType){
      if(courseType == 3) {
        if (this.trainingCourseList.length == 0) {
          this.$message({
            type: "warning",
            message: "未找到相关课程，请联系管理员添加课程"
          });
          return;
        }

        let newRow = {
          CourseId: this.trainingCourseList[0].CourseId,
          CampausId: this.campaus[0].Id,
          TrainingCategoryId: this.trainingCourseList[0].TrainingCategoryId,
          CourseType: courseType
        }
        this.trainings.push(newRow);
      }else if(courseType == 2){
        if (this.englishTrainingCourseList.length == 0) {
          this.$message({
            type: "warning",
            message: "未找到相关课程，请联系管理员添加课程"
          });
          return;
        }

        let newRow = {
          CourseId: this.englishTrainingCourseList[0].CourseId,
          CampausId: this.campaus[0].Id,
          TrainingCategoryId: this.englishTrainingCourseList[0].TrainingCategoryId,
          CourseType: courseType
        }
        this.englishTrainings.push(newRow);
      }
    },
    save() {
      this.saving = true;

      let courseList = [];

      this.universityGroups.forEach(r => {
        courseList = courseList.concat(this.teacherAllCourseList["g" + r.GroupNumber]);
      });

      let data = {
        TeacherCourseList:courseList, 
        TeacherTrainingCourseList: []
      };

      this.trainings.forEach(t => {
        data.TeacherTrainingCourseList.push(t);
      });

      this.englishTrainings.forEach(t => {
        data.TeacherTrainingCourseList.push(t);
      });

      let result = saveSetTeacherCourses(this.teacherId, data).then(result => {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message("保存成功！");
          this.showError = false;
          this.close();
          this.$emit("refreshData");
        }
        this.saving = false;
      });
    },
    close() {
      this.$emit("closeDialog");
      this.teacherAllCourseList = {};
      this.trainings = [];
      this.englishTrainings = [];
      this.showError = false;
      this.errorMessage = "";
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.init();
        } else {
          this.close();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherCourse.vue